import React from 'react';
import styled from 'styled-components';
import { useFieldArray } from 'react-hook-form';
import { currencyOptionsBySite, currenciesBySite } from '@panel/commons/helpers';
import { PillInput } from '@panel/commons/lib/inputs';
import { withQuery } from '@panel/commons/core/themev2';
import { formatAmount } from '@panel/commons/helpers/formatAmount';
import { useTranslation } from 'react-i18next';
import { specialCharactersLock } from '../../../utils/index';
import { ErrorMessage } from './styles';

const DualPriceWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  width: auto;
  max-width: 324px;
  > div {
    max-width: 128px;
    margin-bottom: 20px;
    white-space: nowrap;
  }
  ${withQuery.xs.down()} {
    max-width: 100%;
    > div {
      max-width: 100%;
      width: 100%;
      border-bottom: 1px solid white;
      margin-bottom: 10px;
      &:not(:nth-of-type(1)) {
        margin-top: 10px;
        margin-bottom: 20px;
      }
    }
    > span {
      height: 15px;
    }
  }
`;

const PriceDualSection = ({ siteId, register, errors, control }) => {
  const currencies = currencyOptionsBySite(siteId);
  const { t } = useTranslation();
  const { separator } = Object.values(currenciesBySite[siteId])[0];
  const { fields } = useFieldArray({
    control,
    name: 'price'
  });

  const changePriceFormat = evt => {
    const nonDigits = /^0+|\D/gi;
    const _value = evt.target.value.replaceAll(nonDigits, '');
    evt.target.value = formatAmount(_value);
  };

  return (
    <DualPriceWrapper>
      {fields.map((item, index) => {
        return (
          <div key={`${item.id}`}>
            <PillInput
              ref={register()}
              label={index !== 1 && t(`publisher.step1.module4.price.text`)}
              pillId={`price[${index}].value_unit`}
              inputId={`price[${index}].value`}
              pill={currencies[index]}
              defaultInputValue={item.value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${separator}`)}
              defaultPillValue={item.value_unit}
              inputProps={{
                'data-repa': `S1M4_amount_price_${index}`,
                placeholder: '0',
                onBlur: changePriceFormat,
                onKeyDown: specialCharactersLock,
                onInput: null
              }}
            />
            {errors && errors.price && errors.price[index] && errors.price[index].value.type === 'min' && (
              <ErrorMessage longText data-repa={`S1M4-pill-${item.id}-error-min`}>
                {t(errors.price[index].value.message)}
              </ErrorMessage>
            )}
            {errors &&
              errors.price &&
              errors.price[index] &&
              (errors.price[index].value.type === 'required' || errors.price[index].value.type === 'typeError') && (
                <ErrorMessage data-repa={`S1M4-pill-${item.id}-error-validation`}>
                  {t('publisher.step1.module4.price.validation')}
                </ErrorMessage>
              )}
          </div>
        );
      })}
      <div>
        <PillInput
          ref={register()}
          label={t(`publisher.step1.module4.expenses.text`)}
          pillId='CFT6.value_unit'
          inputId='CFT6.value'
          inputProps={{
            'data-repa': `S1M4_amount_expenses`,
            placeholder: '0',
            onBlur: changePriceFormat,
            onKeyDown: specialCharactersLock,
            onInput: null
          }}
          pill={currencies[0]}
        />
        {errors.CFT6 && (
          <ErrorMessage data-repa='S1M4-pill-exp-error-max'>{`${t('publisher.step3.module1.validation.max')} ${
            errors.CFT6.value.message
          }`}</ErrorMessage>
        )}
      </div>
    </DualPriceWrapper>
  );
};

export { PriceDualSection };
